import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';

export default function Ordbog() {
  const terms = [
    {
      term: 'Afkøling',
      definition:
        'Forskellen mellem temperaturen på det varme vand, der løber ind i radiatoren (fremløbet), og det afkølede vand, der forlader den (returen). Jo større afkøling, desto mere effektivt har anlægget udnyttet varmen.',
      links: [
        { to: '/radiator-kold-i-bunden', text: 'Radiator kold i bunden' },
        { to: '/fjernvarme-radiator-virker-ikke', text: 'Fjernvarme og afkøling' },
        { to: '/spar-paa-varmen', text: 'Spar på varmen' },
      ],
    },
    {
      term: 'Returtemperatur',
      definition:
        'Temperaturen på radiatorvandet, når det løber ud af radiatoren eller forlader boligens fjernvarmeunit. En lav returtemperatur (helst under 30–35 °C) er afgørende for god driftsøkonomi.',
      links: [
        { to: '/radiator-returventil', text: 'Returventil og indstilling' },
        { to: '/fjernvarme-radiator-virker-ikke', text: 'Returtemperatur ved fjernvarme' },
        { to: '/radiator-kold-i-bunden', text: 'Hvorfor bunden skal være kølig' },
      ],
    },
    {
      term: 'Forindstilling',
      definition:
        'En justérbar ventilåbning inde i radiatorventilhuset (eller i returforskruningen), der begrænser den maksimale vandgennemstrømning til den enkelte radiator, uanset hvor højt termostaten skrues op.',
      links: [
        { to: '/radiator-returventil', text: 'Returventil og forindstilling' },
        { to: '/radiator-varmer-ikke', text: 'Radiatoren varmer ikke' },
        { to: '/radiator-larmer', text: 'Susen fra forindstillet ventil' },
      ],
    },
    {
      term: 'Fjernføler',
      definition:
        'Et termostathoved, hvor temperaturføleren er forbundet til ventilen via et tyndt kapillarrør (1–2 meter) og placeret frit på væggen. Anvendes når radiatoren er gemt bag radiatorskjuler eller tunge gardiner.',
      links: [
        { to: '/radiator-termostat', text: 'Radiatortermostater forklaret' },
        { to: '/radiator-termostat-indstilling', text: 'Indstilling af termostater' },
        { to: '/spar-paa-varmen', text: 'Placering og frirum' },
      ],
    },
    {
      term: 'Luftskrue (udlufterventil)',
      definition:
        'En lille ventil monteret øverst i radiatorens modsatte ende af termostaten. Åbnes med en firkantet radiatornøgle for at slippe ophobet luft ud af radiatorkroppen.',
      links: [
        { to: '/udluftning-af-radiator', text: 'Sådan lufter du en radiator ud' },
        { to: '/radiator-luftskrue-sidder-fast', text: 'Luftskruen sidder fast' },
        { to: '/radiator-lyder-som-vand', text: 'Rislende vand i radiatoren' },
      ],
    },
    {
      term: 'Pakdåse',
      definition:
        'Den udskiftelige messingindsats, der sidder foran på ventilhuset bag termostathovedet. Indeholder en gummipakning og den lille 2–3 mm bevægelige stålstift, der regulerer vandstrømmen.',
      links: [
        { to: '/radiator-ventil-sidder-fast', text: 'Ventilstiften sidder fast' },
        { to: '/radiator-laekker', text: 'Lækage fra pakdåsen' },
        { to: '/radiator-varmer-ikke-efter-udluftning', text: 'Varmer ikke efter udluftning' },
      ],
    },
    {
      term: 'Anlægstryk',
      definition:
        'Det statiske vandtryk inde i et lukket centralvarmesystem, aflæst på et manometer i bar. I et standard enfamiliehus skal driftstrykket normalt ligge omkring 1,5 bar ved koldt anlæg.',
      links: [
        { to: '/radiator-tryk', text: 'Trykket i varmeanlægget er faldet' },
        { to: '/udluftning-af-radiator', text: 'Trykkontrol efter udluftning' },
        { to: '/radiator-varmer-ikke', text: 'Manglende tryk i anlægget' },
      ],
    },
    {
      term: 'Strengregulering',
      definition:
        'Indregulering af varmeanlæggets forskellige forgreninger (strenge) og radiatorer med reguleringsventiler, så vandet fordeles jævnt i hele ejendommen uden at overophede de nærmeste radiatorer.',
      links: [
        { to: '/radiator-returventil', text: 'Returventil og strengregulering' },
        { to: '/radiator-banker-fjernvarme', text: 'Trykstød og regulering' },
        { to: '/gammel-radiator-varmer-ikke', text: 'Ubalance i ældre anlæg' },
      ],
    },
    {
      term: 'Konvektor / Konvektion',
      definition:
        'Den proces, hvor kold luft suges ind under radiatoren, varmes op ved kontakt med de indre bølgede stållameller og stiger naturligt til vejrs for at skabe cirkulation i rummet.',
      links: [
        { to: '/hvordan-virker-en-radiator', text: 'Hvordan virker en radiator?' },
        { to: '/radiator-og-varmepumpe', text: 'Konvektion ved varmepumper' },
        { to: '/radiator-udskiftning-pris', text: 'Dimensionering af radiatorer' },
      ],
    },
    {
      term: 'Termisk ekspansion (varmeudvidelse)',
      definition:
        'Den fysiske udvidelse af metaller (stål, kobber og støbejern), når de opvarmes af varmt vand. Hvis rør sidder fastklemt i gulve eller vægge, skaber udvidelsen mekaniske klikke- og tikkelyde.',
      links: [
        { to: '/radiator-klikker', text: 'Hvorfor klikker radiatoren?' },
        { to: '/radiator-larmer', text: 'Larm og rørstøj' },
      ],
    },
  ];

  return (
    <article className="article-container text-[#221E1B]">
      <SeoHead
        title="VVS-ordbog: Fagudtryk om radiatorer og varmeanlæg"
        description="Forklaring af vigtige fagudtryk: afkøling, returtemperatur, forindstilling, fjernføler, luftskrue, pakdåse, anlægstryk og strengregulering."
        canonicalPath="/ordbog"
      />

      <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-[#221E1B] leading-tight mb-4">
        Ordbog: Fagudtryk om radiatorer og varme
      </h1>

      <p className="text-[17px] leading-[1.65] text-[#221E1B] mb-8">
        Korte, praktiske definitioner på de centrale tekniske begreber, som VVS-installatører, forsyningsselskaber og vejledninger benytter.
      </p>

      <div className="space-y-8">
        {terms.map((item, idx) => (
          <section
            key={idx}
            className="p-5 bg-[#F7F3EE] border border-[#E6DED5] rounded space-y-2"
          >
            <h2 className="text-lg font-bold text-[#B5531E]">
              {item.term}
            </h2>
            <p className="text-[16px] leading-[1.65] text-[#221E1B]">
              {item.definition}
            </p>
            <div className="pt-2 text-sm text-[#6B625B]">
              <span className="font-semibold text-[#221E1B]">Læs vejledning:</span>{' '}
              {item.links.map((link, lIdx) => (
                <span key={lIdx}>
                  <Link
                    to={link.to}
                    className="text-[#B5531E] hover:underline underline-offset-4"
                  >
                    {link.text}
                  </Link>
                  {lIdx < item.links.length - 1 ? ' · ' : ''}
                </span>
              ))}
            </div>
          </section>
        ))}
      </div>

      <div className="mt-12 pt-6 border-t border-[#E6DED5] flex items-center justify-between text-sm">
        <Link to="/" className="text-[#B5531E] hover:underline font-medium">
          ← Tilbage til forsiden
        </Link>
        <Link to="/om" className="text-[#6B625B] hover:text-[#B5531E] hover:underline">
          Om Radiatorproblemer.dk
        </Link>
      </div>
    </article>
  );
}
